import type { LanguageAI } from 'src/types/languageAI';

export const getLanguageAI = (language?: LanguageAI) => {
  switch (language) {
    case 'en-AU':
      return 'English';
    case 'id-ID':
      return 'Bahasa';
    case 'th-TH':
      return 'Thai';
    case 'zh-HK':
      return 'Chinese';
    default:
      return 'English';
  }
};
